import * as React from 'react';
import ReactPlayer from 'react-player';

import Iframe from '../Iframe/Iframe';
import { track } from '../../utils/analytics';
import { Link } from '../Link/Link';
import { getLinkHost, getLinkPath, getLinkSearch } from '../../utils/link';

interface Props {
  url: string;
}

const APPLE_HOST = 'podcasts.apple.com';
const SPOTIFY_HOST = 'open.spotify.com';

// Supports Apple, Spotify, and audio file paths.
export const AudioEmbed = ({ url }: Props) => {
  const host = getLinkHost(url);
  const path = getLinkPath(url);
  const search = getLinkSearch(url);

  const handlePlay = () => {
    track('event-media-play-audio', url);
  };

  if (host === APPLE_HOST) {
    return (
      <Iframe
        title={url}
        allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write"
        frameBorder="0"
        height="175"
        width="100%"
        style={{ overflow: 'hidden', background: 'transparent' }}
        sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation"
        src={`https://embed.podcasts.apple.com/${path}${search}`}
        onInferredClick={handlePlay}
      />
    );
  }

  if (host === SPOTIFY_HOST) {
    return (
      <Iframe
        title={url}
        style={{ borderRadius: '12px' }}
        src={`https://open.spotify.com/embed/${path}?theme=0`}
        width="100%"
        height="152"
        frameBorder="0"
        allowFullScreen
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
        onInferredClick={handlePlay}
      />
    );
  }

  const fallback = (
    <Link to={url} target="_blank">
      {url}
    </Link>
  );

  return (
    <ReactPlayer
      url={url}
      controls
      playsinline
      pip
      width="100%"
      height="60px"
      fallback={fallback}
      onStart={handlePlay}
      config={{
        file: {
          forceAudio: true,
        },
      }}
    />
  );
};
